(function ($) {
    let modalNarrow = $('.modal-narrow');
    let id = modalNarrow.attr('modal-id');
    if(modalNarrow.length){
        $(window).on('load', function () {
            if(!getCookie("wp-modal-narrow-"+id)) {
                modalNarrow.addClass('active');
                $('body').addClass('fixed');
            }
        });
        $('.modal-narrow .close-btn').on('click',function(){
            $(this).parents('.modal-narrow').removeClass('active');
            let popup_frequency = $(this).parents('.modal-narrow').attr('data-frequency');
            let popup_id = $(this).parents('.modal-narrow').attr('modal-id');
            $('body').removeClass('fixed');
            WriteCookie(popup_frequency,popup_id);
        })
        $(document).on('keyup',function(evt) {
            if (evt.keyCode === 27) {
                $('.modal-narrow').removeClass('active');
                let popup_frequency = $('.modal-narrow').attr('data-frequency');
                let popup_id = $('.modal-narrow').attr('modal-id');
                $('body').removeClass('fixed');
                WriteCookie(popup_frequency,popup_id);
            }
        });

        $('.modal-narrow .modal-narrow-link').on('click', function(e) {
            e.preventDefault();
            let popup_frequency = $(this).parents('.modal-narrow').attr('data-frequency');
            let popup_id = $(this).parents('.modal-narrow').attr('modal-id');
            WriteCookie(popup_frequency,popup_id);
            window.location.href = $(this).attr('href');
        });
    }
})(jQuery);
function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function WriteCookie(frequency, id) {
    const date = new Date();
    let freq = frequency;
    let modal_id = id;
    date.setTime(date.getTime() + (freq * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = "wp-modal-narrow-"+modal_id+"=1;" + expires + "; path=/";
}
